<script>
import { taxTypeMap,carrierTypeMap } from '@utils/filter-value-to-text'
import cloneDeep from 'lodash/cloneDeep'
import lazyLoadComponent from '@router/lazyload-component'

const extraInfoPhone ={
  // type:'phone',
  phoneCode:'+886',
  phoneNumber:''
}

const extraInfoEmergency ={
  // type:'emergency',
  phoneCode:'+886',
  phoneNumber:'',
  fullName:'',
  gender:'male'
}

export default {
  components: {
    InvoiceForm: () => lazyLoadComponent(import('@components/InvoiceForm')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      taxTypeMap,
      carrierTypeMap,
      // submitData: cloneDeep(Object.assign({}, 
      // { 
      //   extraInfos:{
      //     extraInfoPhone:[extraInfoPhone],
      //     extraInfoEmergency:[extraInfoEmergency]
      //   }
      // },
      // this.defaultValue, { merchantNote: this.defaultValue.merchantNote && this.defaultValue.merchantNote.replace(/<br\s\/>/g, '') },
      // // {extraInfos:this.defaultValue.extraInfos[0]?cloneDeep(this.defaultValue.extraInfos):[extraInfoPhone,extraInfoEmergency]}
      // )),
      default: cloneDeep(this.value) ,
      // editDetailEnabled : false,
      editDetailEnabled: false
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    storeInvoiceSetting() {
      return this.submitData.storeInvoiceSetting === 1
    },
  },
  watch: {

  },
  created() {

  },
  mounted() {
  },
  methods: {
    enableEditInvoice() {
      const data = {
        isEditEnabled: true,
        type: 'tax'
      }
      this.editDetailEnabled = true
      this.$emit('isEditDeatilEnabled', data)
    },
  },
}
</script>

<template>
  <div>
    <BasePageHeader 
      title="發票資訊" 
    >
      <template v-slot:right>
        <el-button
          v-if="!editDetailEnabled" 
          type="primary"
          class="is-round isStyleBase"
          @click="enableEditInvoice"
        >
          編輯發票資訊
        </el-button>
      </template>
    </BasePageHeader>
    <div class="isStylePageContent">
      <template v-if="storeInvoiceSetting">
        <h4 class="form-block-title"
          >發票資訊
          <!-- <template v-if="editDetailEnabled">
            <el-button class="is-round" size="mini" @click="cancelEditInvoice">取消</el-button>
            <el-button :loading="saveLoading['tax']" class="is-round" size="mini" type="primary" @click="saveEdit('tax')">
              <BaseIcon name="check" />
              <span>儲存</span>
            </el-button>
          </template>
          <el-button v-else class="is-round" size="mini" @click="enableEditInvoice">
            <BaseIcon name="edit" />
            <span>編輯</span>
          </el-button> -->
        </h4>
        <ul :class="$style.detail">
          <template v-if="editDetailEnabled">
            <el-form ref="form" class="el-form-item--normal-margin" :model="submitData" :class="$style['detail-form']" label-position="left" label-width="100px">
              <InvoiceForm :default-value="submitData" :show-sync="false" />
            </el-form>
          </template>
          <template v-else>
            <li>開立類型：{{ taxTypeMap[submitData.taxType] }}</li>
            <template v-if="submitData.taxType === 'B2C'">
              <li>載具類別：{{ carrierTypeMap[submitData.CarrierType] || '無（寄送電子發票至客戶 email）' }}</li>
              <li v-if="submitData.CarrierType === '0' || submitData.CarrierType === '1'">載具編號：{{ submitData.CarrierNum }}</li>
            </template>
            <li v-else-if="submitData.taxType === 'B2B'">統一編號：{{ submitData.taxId }}</li>
            <li v-else>捐贈碼：{{ submitData.LoveCode }}</li>
          </template>
        </ul>
      </template>
    </div>
  </div>
</template>
<style lang="scss" module>
.detail li {
  line-height: 40px;
}
.label-tag {
  :global {
    .el-tag {
      border-color: #808080;
      border-radius: 3px;
      height: 25px;
      line-height: 25px;
      color: #808080;
      margin-bottom: 10px;
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
  }
}
.footer {
  display: flex;
  :global {
    button {
      flex: 1 0 auto;
    }
  }
}
.detail-form {
  width:550px;

  @include max-sm {
    width: 100%;
  }
  :global {
    .el-input-group__append,
    .el-input-group__prepend {
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
